import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FileDropZone } from '@/components/common';
import { Label, LABEL_TYPE } from '@/components/generic';
import { DroppedAssetPopup } from '@/pages/Event/Asset/DroppedAssetPopup';
import { AddSquareIcon } from '@/resources';
import { Asset } from '@/types';

interface DeviceScheduleUploadContentProps {
  uploadedAsset: Asset | null;
  onAssetCreated: (asset: Asset) => void;
}

export const DeviceScheduleUploadContent = ({
  uploadedAsset,
  onAssetCreated
}: DeviceScheduleUploadContentProps) => {
  const [t] = useTranslation('common');
  const [showDropPopup, setShowDropPopup] = useState(false);
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);

  const handleFileDrop = (files: File[]) => {
    setDroppedFiles(files);
    setShowDropPopup(true);
  };

  const handleClosePopup = () => {
    setShowDropPopup(false);
    setDroppedFiles([]);
  };

  return (
    <>
      {uploadedAsset && (
        <div className='mt-4 flex w-full items-start gap-4 p-4'>
          <div className='flex w-32 flex-col items-center gap-2'>
            <div className='relative size-32 shrink-0'>
              {uploadedAsset.thumbnailUrl ? (
                <img
                  src={uploadedAsset.thumbnailUrl}
                  alt={uploadedAsset.assetName}
                  className='size-full rounded object-cover'
                />
              ) : (
                <div className='flex size-full items-center justify-center rounded bg-gray-200'>
                  <AddSquareIcon className='size-8 text-gray-400' />
                </div>
              )}
            </div>

            <p
              className='w-32 overflow-hidden truncate text-center text-sm font-normal'
              title={uploadedAsset.assetName}>
              {uploadedAsset.assetName}
            </p>
          </div>
        </div>
      )}
      {!uploadedAsset && (
        <FileDropZone
          onDrop={handleFileDrop}
          allowMultipleFiles={false}
          className='relative mt-4 flex min-h-[140px] w-full flex-col items-center justify-center rounded-2xl border border-secondary-blue-gray bg-[#F3F6FD52] py-8 transition-colors duration-200'
          activeClassName='bg-color-light-blue ring-4 ring-accent-light-blue'>
          <div className='flex flex-col items-center justify-center gap-y-2'>
            <AddSquareIcon className='size-6 text-secondary-gray' />
            <Label
              text={t('dragAndDropNewAssetHere')}
              type={LABEL_TYPE.PARAGRAPH1}
              className='!text-center !text-secondary-gray'
            />
          </div>
        </FileDropZone>
      )}

      {showDropPopup && (
        <DroppedAssetPopup
          files={droppedFiles}
          onClose={handleClosePopup}
          isPublic={false}
          handleCreatedAsset={onAssetCreated}
        />
      )}
    </>
  );
};
